<div class="confirm-action-dialog flex-left-column light-control-host">
  <div class="modal-header">
    <h3 class="panel-title">{{ action }} {{ name }}</h3>
    <button
      type="button"
      class="modal-close-btn"
      (click)="onCancelClick()"
      pTooltip="Close"
      tooltipPosition="left"
      aria-label="Close"
    >
      <svg lucideX></svg>
    </button>
  </div>
  <ng-content></ng-content>
  <div class="error margin-top">This is a permanent action that cannot be undone.</div>
  <form [formGroup]="confirmActionFormModel" class="flex-left-column full-width" (ngSubmit)="onActionClick()">
    @if (error === null) {
      <div class="margin-top flex-center-row full-width">
        <div>To acknowledge, type "I understand":</div>
        <input
          id="action-confirmation"
          formControlName="confirmation"
          class="margin-left arpio-input spacer"
          focus-element
        />
      </div>
    }
    @if (error != null) {
      <div class="margin-top full-width">
        <h4>Unable to {{ action }} {{ name }}</h4>
        <div class="error">{{ error }}</div>
      </div>
    }
    <!-- Footer uses the shared .modal-footer pattern: Cancel on the left,
    destructive action on the right. Cancel is disabled during an
    in-flight action so Esc/click can't abort a request mid-flight. -->
    <div class="modal-footer">
      <button class="arpio-secondary-button" (click)="onCancelClick()" type="button" [disabled]="busy">Cancel</button>
      <p-button
        pRipple
        data-cy="confirm-action-button"
        [loading]="busy"
        severity="danger"
        type="submit"
        [disabled]="!actionEnabled"
        [label]="actionButtonText"
      ></p-button>
    </div>
  </form>
</div>
